import "./Header.scss";

import { AppRoutes } from "AppRoutes";
import { Breadcrumb } from "components/Breadcrumb/Breadcrumb";
import { useLayout, usePermissions, useTranslations } from "providers";
import React, { useState } from "react";

import { HamburgerIcon } from "./HamburgerIcon";
import { HamburgerMenu } from "./HamburgerMenu";
import { HeaderNavItem } from "./HeaderNavItem";
import { HelpButton } from "./HelpButton";
import { LanguageMenu } from "./LanguageMenu";
import { SbbHeaderEnvironment } from "./SbbHeaderEnvironment";
import { UserMenu } from "./UserMenu";

export const Header: React.FC = () => {
  const i18n = useTranslations();
  const { permissions } = usePermissions();
  const { navItems = [] } = useLayout();
  const [languageMenuOpen, setLanguageMenuOpen] = useState<boolean>(false);
  const [userMenuOpen, setUserMenuOpen] = useState<boolean>(false);

  return (
    <div className="header-container">
      <header className="sbb-header">
        <SbbHeaderEnvironment />
        <div className="sbb-header-titlebox">
          <div className="sbb-header-appname">
            <a href={AppRoutes.Home} rel="logo">
              {i18n.ApplicationName}
            </a>
          </div>
          <div className="sbb-header-appversion">
            <a href={AppRoutes.toAbout()}>
              {i18n.Header_Version}{" "}
              {permissions && (
                <span className="global-tooltip-trigger" title={permissions.fullSemVer}>
                  {permissions.fileVersion}
                </span>
              )}
            </a>
          </div>
        </div>

        <div className="sbb-header-nav d-block d-xl-none">
          <HamburgerIcon />
        </div>

        <div className="sbb-header-nav d-none d-xl-block">
          {/* show on large breakpoints only */}
          <div className="d-flex">
            {navItems.map((item, i) => {
              if (item.disabled) return null;
              return (
                <React.Fragment key={`nav-item-${i}`}>
                  <HeaderNavItem {...item} />
                </React.Fragment>
              );
            })}
          </div>
        </div>

        <nav className="sbb-header-nav sbb-header-nav-end">
          <HelpButton />
          <LanguageMenu isOpen={languageMenuOpen} setIsOpen={setLanguageMenuOpen} />
          <UserMenu isOpen={userMenuOpen} setIsOpen={setUserMenuOpen} />
        </nav>

        <div className="sbb-header-container-end">
          <div className="sbb-header-logo ng-tns-c1-1">
            <svg className="ng-tns-c1-1" viewBox="0 0 80 21" xmlns="http://www.w3.org/2000/svg">
              <path className="ng-tns-c1-1" d="M0 0h59.233v20.603H0V0z" fill="#EC0000" />
              <path
                className="ng-tns-c1-1"
                d="M35.186 17.02h3.75l-5.047-5.163h6.265v5.163h2.96v-5.163h6.267l-5.05 5.163h3.752l6.427-6.708-6.426-6.73h-3.752l5.05 5.185h-6.266V3.583h-2.96v5.184h-6.267l5.047-5.184h-3.75l-6.43 6.73 6.43 6.707"
                fill="#FFF"
              />
            </svg>
          </div>
        </div>
      </header>
      <Breadcrumb />
      <HamburgerMenu />
    </div>
  );
};
